import axios from "axios";
import Config from "../../../config";

const v2_actionUploadCustomField = (leadId, fieldId, formData) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/leads/${leadId}/custom-fields/${fieldId}/upload`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
    });
};

export default v2_actionUploadCustomField;
